const FILE_SIZE_UNITS = ['Bytes', 'KB', 'MB', 'GB'] as const;

/** Human-readable file size, e.g. `1.44 MB`. */
export function formatFileSize(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes <= 0) return '0 Bytes';

  const exponent = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    FILE_SIZE_UNITS.length - 1,
  );
  const unit = FILE_SIZE_UNITS[exponent] ?? 'Bytes';
  const value = bytes / Math.pow(1024, exponent);

  return `${String(Number.parseFloat(value.toFixed(2)))} ${unit}`;
}
